import clsx from "clsx";
import React, { createElement } from "react";
import { appTextClassMap } from "@/components/Text/constants";

interface AppTextProps {
    children: React.ReactNode;
    variant:
        | "headings"
        | "subheadings"
        | "contextheading"
        | "labelsbuttons"
        | "regular"
        | "footnote";
    className?: string;
    applyGradient?: boolean;
    as?: React.ElementType;
    style?: React.CSSProperties;
}

export const AppText = ({
    children,
    variant,
    className,
    applyGradient,
    as,
    style,
}: AppTextProps) => {
    const { element, elementClassName } = appTextClassMap[variant];
    return createElement(
        as || element,
        {
            className: clsx(
                elementClassName,
                className,
                applyGradient && [
                    "bg-gradient-primary",
                    "bg-clip-text",
                    "text-transparent",
                ],
            ),
            style,
        },
        children,
    );
};
